import { ProductSearchCard } from 'components/product/cards';
import { Skeleton } from 'components/ui';
import IconSgr from 'components/ui/icons/IconSgr';
import { SGR_BAG_SKU } from 'helpers/ProductHelpers';
import { cx } from 'helpers/StylingHelpers';
import { useProductsBySku } from 'hooks/data/useProductsBySku';

import type { IAnalyticsListProps } from 'types';

import styles from './ProductDetailsSGRWidget.module.scss';

interface Props {
  className?: string,
  listProps?: IAnalyticsListProps
}

const SKUS = [SGR_BAG_SKU];
const ANALYTICS_LIST_ID_PREFIX = 'sacsgr';

const ProductDetailsSGRWidget = (props: Props) => {
  const { className, listProps } = props;
  const { data: products, isLoading } = useProductsBySku(SKUS);

  if (isLoading) {
    return (
      <div className={cx(styles.skeleton, styles.root)}>
        <Skeleton className={styles.iconSkeleton} />
        <Skeleton containerClassName={styles.skeletonContainer} className={styles.contentSkeleton} />
      </div>
    );
  }

  if (!products?.[0]?.isAvailable) return null;
  const product = products[0];

  return (
    <div className={styles.root}>
      <div className={styles.iconWrapper}>
        <IconSgr size={29} className={styles.icon} />
      </div>
      <ProductSearchCard
        classNames={{
          root: cx(styles.card, className),
          taxes: styles.taxes,
          quantityButton: styles.quantityButton,
          content: styles.cardContent
        }}
        //
        product={product}
        bypassQuantityVariants
        listProps={listProps ? {
          ...listProps,
          analyticsListId: `${ANALYTICS_LIST_ID_PREFIX}_${listProps.analyticsListId}`
        } : undefined}
        //
        inline
        isCheckoutBuyMoreProduct
        inlinePrice={false}
        //
        withoutLink
        withoutBrand
        withoutImage
        withoutTaxes
        withoutAddToCarText
        isAddToCartPrimary
      />
    </div>
  );
};

export default ProductDetailsSGRWidget;
